/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export { default as StarRating } from "./StarRating";
export type { StarRatingProps } from "./StarRatingProps";
